import React from "react";

export class Privacy extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
        
            <div style={{          
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                paddingLeft: '20%',
                paddingRight: '20%'}}>

<h3>POLÍTICA DE PRIVACIDADE</h3>
    <p>
        Este aplicativo é mantido e operado por sorteash.
        Nós coletamos e utilizamos alguns dados pessoais que pertencem àqueles que utilizam nosso aplicativo. Ao
        fazê-lo, agimos
        na qualidade de controlador desses dados e estamos sujeitos às disposições da Lei Federal n. 13.709/2018 (Lei
        Geral de
        Proteção de Dados Pessoais - LGPD).</p>
    <p>
        Nós cuidamos da proteção de seus dados pessoais e, por isso, disponibilizamos esta política de privacidade, que
        contém
        informações importantes sobre:
        - Quem deve utilizar nosso aplicativo - Quais dados coletamos e o que fazemos com eles; - Seus direitos em
        relação aos
        seus dados pessoais; e - Como entrar em contato conosco.</p>
    <p>
        1. Quem deve utilizar nosso aplicativo
        Nosso aplicativo só deve ser utilizado por pessoas com mais de dezoito anos de idade. Sendo assim, crianças e
        adolescentes não devem utilizá-lo.
        2. Dados que coletamos e motivos da coleta
        Nosso aplicativo coleta e utiliza alguns dados pessoais de nossos usuários, de acordo com o disposto nesta
        seção.
        1. Dados pessoais fornecidos expressamente pelo usuário Nós coletamos os seguintes dados pessoais que nossos
        usuários
        nos fornecem expressamente ao utilizar nosso aplicativo:
        Apenas o primeiro nome e telefone
        A coleta destes dados ocorre nos seguintes momentos: ao entrar no aplicativo
        Os dados fornecidos por nossos usuários são coletados com as seguintes nalidades:
        para contato caso haja contemplação do usuario
        2. Dados sensíveis Não serão coletados dados sensíveis de nossos usuários, assim entendidos aqueles denidos nos
        arts. 11
        e seguintes da Lei de Proteção de Dados Pessoais. Assim, não haverá coleta de dados sobre origem racial ou
        étnica,
        convicção religiosa, opinião política, liação a sindicato ou a organização de caráter religioso, losóco ou
        político,
        dado referente à saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma pessoa natural.
        3. Coleta de dados não previstos expressamente Eventualmente, outros tipos de dados não previstos expressamente
        nesta
        Política de Privacidade poderão ser coletados, desde que sejam fornecidos com o consentimento do usuário, ou,
        ainda, que
        a coleta seja permitida com fundamento em outra base legal prevista em lei. Em qualquer caso, a coleta de dados
        e as
        atividades de tratamento dela decorrentes serão informadas aos usuários do aplicativo.
        3. Compartilhamento de dados pessoais com terceiros
        Nós não compartilhamos seus dados pessoais com terceiros. Apesar disso, é possível que o façamos para cumprir
        alguma
        determinação legal ou regulatória, ou, ainda, para cumprir alguma ordem expedida por autoridade pública.
        4. Por quanto tempo seus dados pessoais serão armazenados
        Os dados pessoais coletados pelo aplicativo são armazenados e utilizados por período de tempo que corresponda ao
        necessário para atingir as nalidades elencadas neste documento e que considere os direitos de seus titulares, os
        direitos do controlador do aplicativo e as disposições legais ou regulatórias aplicáveis. Uma vez expirados os
        períodos
        de armazenamento dos dados pessoais, eles são removidos de nossas bases de dados ou anonimizados, salvo nos
        casos em que
        houver a possibilidade ou a necessidade de armazenamento em virtude de disposição legal ou regulatória.
        5. Bases legais para o tratamento de dados pessoais Cada operação de tratamento de dados pessoais precisa ter um
        fundamento jurídico, ou seja, uma base legal, que nada mais é que uma justicativa que a autorize, prevista na
        Lei Geral
        de Proteção de Dados Pessoais. Todas as Nossas atividades de tratamento de dados pessoais possuem uma base legal
        que as
        fundamenta, dentre as permitidas pela legislação. Mais informações sobre as bases legais que utilizamos para
        operações
        de tratamento de dados pessoais especícas podem ser obtidas a partir de nossos canais de contato, informados ao
        nal
        desta Política.
    </p>
    <p>
        6.
        1. Como o titular pode exercer seus direitos
        Os titulares de dados pessoais tratados por nós poderão exercer seus direitos por meio do formulário
        disponibilizado no
        seguinte caminho: https://www.sorteash.com/regulamento. Alternativamente, se desejar, o titular poderá enviar um
        e-mail
        ou uma correspondência ao nosso Encarregado de Proteção de Dados Pessoais. As informações necessárias para isso
        estão na
        seção "Como entrar em contato conosco" desta Política de Privacidade.
        Os titulares de dados pessoais tratados por nós poderão exercer seus direitos a partir do envio de mensagem ao
        nosso
        Encarregado de Proteção de Dados Pessoais, seja por e-mail ou por correspondência. As informações necessárias
        para isso
        estão na seção "Como entrar em contato conosco" desta Política de Privacidade. Para garantir que o usuário que
        pretende
        exercer seus direitos é, de fato, o titular dos dados pessoais objeto da requisição, poderemos solicitar
        documentos ou
        outras informações que possam auxiliar em sua correta identicação, a m de resguardar nossos direitos e os
        direitos de
        terceiros. Isto somente será feito, porém, se for absolutamente necessário, e o requerente receberá todas as
        informações
        relacionadas.
        7. Medidas de segurança no tratamento de dados pessoais
        Empregamos medidas técnicas e organizativas aptas a proteger os dados pessoais de acessos não autorizados e de
        situações
        de destruição, perda, extravio ou alteração desses dados. As medidas que utilizamos levam em consideração a
        natureza dos
        dados, o contexto e a nalidade do tratamento, os riscos que uma eventual violação geraria para os direitos e
        liberdades
        do usuário, e os padrões atualmente empregados no mercado por empresas semelhantes à nossa.
        Entre as medidas de segurança adotadas por nós, destacamos as seguintes: - Os dados de nossos usuários são
        armazenados
        em ambiente seguro; - Limitamos o acesso aos dados de nossos usuários, de modo que terceiros não autorizados não
        possam
        acessá-los; - Mantemos registros de todos aqueles que têm, de alguma forma, contato com nossos dados.
        Ainda que adote tudo o que está ao seu alcance para evitar incidentes de segurança, é possível que ocorra algum
        problema
        motivado exclusivamente por um terceiro - como em caso de ataques de hackers ou crackers ou, ainda, em caso de
        culpa
        exclusiva do usuário, que ocorre, por exemplo, quando ele mesmo transfere seus dados a terceiro. Assim, embora
        sejamos,
        em geral, responsáveis pelos dados pessoais que tratamos, nos eximimos de responsabilidade caso ocorra uma
        situação
        excepcional como essas, sobre as quais não temos nenhum tipo de controle. De qualquer forma, caso ocorra
        qualquer tipo
        de incidente de segurança que possa gerar risco ou dano relevante para qualquer de nossos usuários,
        comunicaremos os
        afetados e a Autoridade Nacional de Proteção de Dados acerca do ocorrido, em conformidade com o disposto na Lei
        Geral de
        Proteção de Dados.
        8.
        9. Alterações nesta política A presente versão desta Política de Privacidade foi atualizada pela última vez em:
        23/06/2022.
        Reservamo-nos o direito de modicar, a qualquer momento, as presentes normas, especialmente para adaptá-las às
        eventuais
        alterações feitas em nosso aplicativo, seja pela disponibilização de novas funcionalidades, seja pela supressão
        ou
        modicação daquelas já existentes.
        Sempre que houver uma modicação, nossos usuários serão noticados acerca da mudança.
    </p>
    <p>
        10. Como entrar em contato conosco
        Para esclarecer quaisquer dúvidas sobre esta Política de Privacidade ou sobre os dados pessoais que tratamos,
        entre em
        contato com nosso Encarregado de Proteção de Dados Pessoais, por algum dos canais mencionados abaixo:
        E-mail: besonquadros@gmail.com Endereço postal: Murilo braga - São Pedro - Teresina PI
    </p>


            </div>
        
        
        );
    }


}






export default Privacy;
